require("../../sass/core.sass");

import { ApolloProvider } from "react-apollo";
import client from "../helpers/apollo-client";

import {
    useRouterHistory,
    createMemoryHistory,
    IndexRoute,
    Switch,
} from "react-router";
import { Router, Route } from "react-router-dom";
import history from "../helpers/history";
let Provider = require("react-redux").Provider;
import React from "react";
import Homepage from "../components/nounproject-homepage";
import NounProjectResults from "../components/nounproject-results";
import ForEdu from "../components/nounproject-for-edu";
import DownloadHistory from "../components/download-history";
import EduLoginPage from "../components/auth/login/edu-login-page";
import EduSignupPage from "../components/auth/signup/edu-signup-page";
import EduBilling from "../components/billing/forms/edu-billing/edu-billing";
import EduApply from "../components/nounproject-edu-application";
import InvoiceList from "../components/invoice-list";
import InvoiceEdit from "../components/invoice-edit";
import IconDetail from "../containers/nounproject-icon-detail";
import { IconRow } from "../components/nounproject-iconlist-classic-row";
import InfiniteDeniedUploads from "../components/dashboard/inactive-uploads/infinite-denied-uploads";
import InfinitePendingUploads from "../components/dashboard/inactive-uploads/infinite-pending-uploads";
import InfiniteCollections from "../components/dashboard/collections/infinite-collections";
import ProUpgradeBilling from "../components/billing/forms/pro-upgrade-billing";
import TeamSignup from "../components/billing/forms/team-signup";
import LoginPage from "../components/auth/login/login-page";
import SignupPage from "../components/auth/signup/signup-page";
import Modal from "./modal";
import Toasts from "./toasts";
import NounContainer from "./nounproject-container";
import PrepaidBalancePage from "../components/PrepaidBalancePage/index";

import store from "../stores/reduxStore";

class NounProject extends React.Component {
    constructor(props) {
        super(props);

        if (props.args) {
            window._nounConfig.args = props.args;
        }
    }

    render() {
        const SignupPageComponent = () => {
            const { signupType, plans, next } = this.props.args;
            return (
                <SignupPage signupType={signupType} plans={plans} next={next} />
            );
        };

        let { args } = this.props;

        return (
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <div style={{ width: "100%" }}>
                        <Router history={history}>
                            <Switch>
                                <Route
                                    exact
                                    path="/"
                                    component={(props) => (
                                        <NounContainer {...props}>
                                            <Homepage />
                                        </NounContainer>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/search"
                                    component={(props) => (
                                        <NounProjectResults
                                            {...props}
                                            pageContext="search"
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path="/browse"
                                    component={(props) => (
                                        <NounProjectResults
                                            {...props}
                                            pageContext="browse"
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path="/term/:term/:iconId?"
                                    component={(props) => (
                                        <NounProjectResults
                                            {...props}
                                            pageContext="termDetail"
                                        />
                                    )}
                                />

                                <Route
                                    exact
                                    path="/:username/collection/:collectionSlug"
                                    component={(props) => (
                                        <NounProjectResults
                                            {...props}
                                            args={args}
                                            pageContext="collectionDetail"
                                        />
                                    )}
                                />

                                <Route
                                    exact
                                    path="/:username/uploads"
                                    component={(props) => (
                                        <NounProjectResults
                                            {...props}
                                            pageContext="userUploads"
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path="/recent"
                                    component={(props) => (
                                        <NounProjectResults
                                            {...props}
                                            pageContext="recent"
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path="/for-edu/"
                                    component={(props) => (
                                        <NounContainer {...props}>
                                            <ForEdu />
                                        </NounContainer>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/accounts/login/"
                                    component={() => <LoginPage {...args} />}
                                />
                                <Route
                                    exact
                                    path="/accounts/signup/"
                                    component={SignupPageComponent}
                                />
                                <Route
                                    exact
                                    path="/accounts/signup/:signupType/"
                                    component={SignupPageComponent}
                                />
                                <Route
                                    exact
                                    path="/for-edu/signup/"
                                    component={(props) => (
                                        <NounContainer
                                            noSearch
                                            hideLoginLink
                                            {...props}
                                        >
                                            <EduSignupPage />
                                        </NounContainer>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/for-edu/login/"
                                    component={(props) => (
                                        <NounContainer
                                            noSearch
                                            hideLoginLink
                                            {...props}
                                        >
                                            <EduLoginPage />
                                        </NounContainer>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/for-edu/apply/"
                                    component={(props) => (
                                        <NounContainer noSearch {...props}>
                                            <EduApply />
                                        </NounContainer>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/for-edu/billing/"
                                    component={(props) => (
                                        <NounContainer noSearch {...props}>
                                            <EduBilling />
                                        </NounContainer>
                                    )}
                                />
                                <Route
                                    exact
                                    path="/:username/settings/upgrade/:pluginApp?/"
                                    component={() => {
                                        const {
                                            args: {
                                                minSeats,
                                                seats,
                                                plans,
                                                couponCode,
                                                source,
                                                accountType,
                                            },
                                        } = this.props;

                                        return accountType === "team" ? (
                                            <TeamSignup
                                                minSeats={minSeats}
                                                seats={seats}
                                                couponCode={couponCode}
                                                plans={plans}
                                            />
                                        ) : (
                                            <ProUpgradeBilling
                                                source={source}
                                            />
                                        );
                                    }}
                                />
                                <Route
                                    exact
                                    path="/:username/settings/invoices/:chargeId/edit/"
                                    component={InvoiceEdit}
                                />
                                <Route
                                    exact
                                    path="/:username/settings/invoices/:chargeId?/"
                                    component={InvoiceList}
                                />
                                <Route
                                    exact
                                    path="/:username/settings/invoices/"
                                    component={InvoiceList}
                                />
                                <Route
                                    exact
                                    path="/:username/settings/icon-history/"
                                    component={DownloadHistory}
                                />
                                <Route
                                    exact
                                    path="/icon/:iconId/"
                                    component={IconDetail}
                                />
                                <Route
                                    exact
                                    path="/:username/icon/:iconId/"
                                    component={IconDetail}
                                />
                                <Route
                                    exact
                                    path="/:username/uploads/denied/"
                                    component={InfiniteDeniedUploads}
                                />
                                <Route
                                    exact
                                    path="/:username/uploads/pending/"
                                    component={InfinitePendingUploads}
                                />
                                <Route
                                    exact
                                    path="/:username/collections/"
                                    component={() => (
                                        <InfiniteCollections
                                            args={this.props.args}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path="/:username/settings/prepaid-balance"
                                    component={PrepaidBalancePage}
                                />
                            </Switch>
                            <Modal />
                        </Router>
                        <Toasts />
                    </div>
                </Provider>
            </ApolloProvider>
        );
    }
}

export default NounProject;
